<template>
<donapp-dialog
  v-show="show"
  :title="orderId"
  header="Fee #"
  :theme="theme"
  :show="show"
  @close="close"
  v-on:submit="pay"
  :footer="false">
  <div class="cell stripe mb10">
    <div v-show="!loading">
      <div class="row error" v-show="error && error.length > 0">
        Error: {{ error }}
      </div>
      <donapp-button class="gradient-merchant" text="Update payment methods" :action="goToPaymentMethods"/>
    </div>
    <div v-if="loading">
      <svg class="circle-loader" width="41" height="41" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="15" />
      </svg>
    </div>
  </div>
</donapp-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import DonappDialog from '@/components/shared/Dialog'
import DonappButton from '@/components/shared/buttons/Button'
import MaterialInput from '@/components/shared/inputs/Material'
import formatter from '@/mixins/Formatter'

export default {
  components: { DonappDialog, MaterialInput, DonappButton },
  mixins: [formatter],
  props: {
    amount: {
      type: Number,
      required: true
    },
    orderId: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: 'merchant'
    },
    show: {
      type: Boolean,
      default: false
    },
    donappError: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: 'id'
    },
    scope: {
      type: String,
      default: 'donation'
    }
  },
  data() {
    return {
      stripeError: undefined
    }
  },
  mounted() {},
  methods: {
    ...mapMutations({
      goTo: 'goTo'
    }),
    goToPaymentMethods: function() {
      this.goTo({
        name: 'MerchantProfile',
        query: { sub: 4, session: Date.now() }
      })
    },
    async pay() {},
    close: function() {
      this.$emit('close')
    }
  },
  computed: {
    ...mapState({
      merchantId: state => state.user.loggedRole.merchant._id
    }),
    error: function() {
      return this.stripeError || this.donappError
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/config.scss';

.stripe .row {
  display: -ms-flexbox;
  display: flex;
  margin: 0 5px 10px;
}

.stripe .field {
  position: relative;
  width: 100%;
  height: 50px;
  margin: 0 10px;
}

.stripe .field.half-width {
  width: 50%;
}

.stripe .field.quarter-width {
  width: calc(25% - 10px);
}

.stripe .baseline {
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  bottom: 0;
  background-color: #cfd7df;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe label {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 8px;
  color: #cfd7df;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: 0 50%;
  cursor: text;
  transition-property: color, transform;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
  pointer-events: none;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}

.stripe .input {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-bottom: 7px;
  color: #32325d;
  background-color: transparent;
}

.stripe .input::-webkit-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input::-moz-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input:-ms-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.stripe .input.StripeElement {
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  will-change: opacity;
}

.stripe .input.focused,
.stripe .input:not(.empty) {
  opacity: 1;
}

.stripe .input.focused::-webkit-input-placeholder,
.stripe .input:not(.empty)::-webkit-input-placeholder {
  color: #cfd7df;
}

.stripe .input.focused::-moz-placeholder,
.stripe .input:not(.empty)::-moz-placeholder {
  color: #cfd7df;
}

.stripe .input.focused:-ms-input-placeholder,
.stripe .input:not(.empty):-ms-input-placeholder {
  color: #cfd7df;
}

.stripe .input.focused + label,
.stripe .input:not(.empty) + label {
  color: #aab7c4;
  transform: scale(0.85) translateY(-25px);
  cursor: default;
}

.stripe .input.focused + label {
  color: #24b47e;
}

.stripe .input.invalid + label {
  color: #ffa27b;
}

.stripe .input.focused + label + .baseline {
  background-color: #24b47e;
}

.stripe .input.focused.invalid + label + .baseline {
  background-color: #e25950;
}

.stripe input,
.stripe button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  border-style: none;
}

.stripe input:-webkit-autofill {
  -webkit-text-fill-color: #e39f48;
  transition: background-color 100000000s;
  -webkit-animation: 1ms void-animation-out;
}

.stripe .StripeElement--webkit-autofill {
  background: transparent !important;
}

.stripe input,
.stripe button {
  -webkit-animation: 1ms void-animation-out;
}

.stripe input:active {
  background-color: #159570;
}

.stripe .error {
  color: #e25950;
}

.stripe .success .icon .border {
  stroke: #abe9d2;
}

.stripe .success .icon .checkmark {
  stroke: #24b47e;
}

.stripe .success .title {
  color: #32325d;
  font-size: 16px !important;
}

.stripe .success .message {
  color: #8898aa;
  font-size: 13px !important;
}

.stripe .success .reset path {
  fill: #24b47e;
}

.stripe button {
  display: block;
  width: calc(100% - 30px);
  height: 40px;
  margin: 15px 15px 0px;
  background-color: #24b47e;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
}

.material-input {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/StripeDialog.vue